var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.appLoaded && _vm.canBuild)?_c('b-button',{staticClass:"builder-button",attrs:{"variant":"light","size":"sm","data-cy":"toggle-builder"},on:{"click":_vm.toggleBuilder}},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }